// src/pages/About.js
import React from "react";

export default function About() {
  return (
    <div className="fade-in">
      <div className="card" style={{ maxWidth: 680, margin: "0 auto" }}>
        <h2 style={{ marginBottom: 20 }}>About ReflectUS</h2>

        <p>
          ReflectUS is an intimate reflection space for partners.
        </p>

        <p>
          It is for people who want to pause and look more clearly at their
          relationship — without pressure, diagnosis, or performance.
        </p>

        <p>
          ReflectUS is not therapy. It does not replace conversation, and it does
          not promise quick fixes.
        </p>

        <p>
          It creates a calm, structured space where reflection can happen without
          defensiveness or the need to resolve anything immediately.
        </p>

        <p>
          The first module offers a clear shared snapshot of the relationship as
          it is right now.
        </p>

        <p>
          A second, optional module focuses more deeply on the individual.
          Based on both private and shared reflections, it looks for possible
          paths to improve the partnership.
          It adds rhythm, boundaries, and continuity — because meaningful
          reflection needs structure to remain productive.
        </p>

        <p>
          Most relationship tools instruct, analyze, or try to fix.
        </p>

        <p>
          ReflectUS does something quieter.
        </p>

        <p>
          Both partners reflect privately. No one sees the other’s words.
          What is shared is only a neutral signal — emotional patterns,
          balance, and overall tone.
          No quotes. No blame.
        </p>

        <p>
          At the core of ReflectUS is advanced, purpose-built artificial
          intelligence, designed specifically for reflective processes between
          people.
        </p>

        <p>
          It does not reassure or soften. It does not take sides.
          It reflects only what is present and supported by what was shared.
        </p>

        <p>
          Over time, changes in tone, engagement, and balance become visible —
          without judgment or narrative.
        </p>

        <p>
          ReflectUS works best when its structure is respected.
          Depth depends on sincerity, not eloquence.
        </p>

        <p>
          If engagement is shallow, that will be reflected.
          If one side disengages, that imbalance will be visible.
        </p>

        <p>
          Nothing is exaggerated. Nothing is hidden.
        </p>

        <p style={{ marginTop: 24 }}>
          ReflectUS is not designed to impress.
          It is designed to be clear.
        </p>
      </div>
    </div>
  );
}